<template>
	<AppDialog :dialogName="'Dynamic Data Mapper'" width="800" max-width="800">
		<template v-slot:header>
			<DialogHeader :service="service" :fieldItem="fieldItem" />
		</template>
		<div class="finished-creating-mapper-dialog">
			<div class="dialog-title">What's next:</div>

			<div class="dialog-body">
				Continue working on your feature normally. When you map data to, or from this SmartSuite application, you'll be prompted to give
				properties a generic name. These generic names will be used to guide your end user when they map their own data.
			</div>

			<div class="dialog-title">Here's a preview of what this will look like:</div>

			<div class="dialog-body">
				<div class="dummy-mapping">
					<div class="flex-start--center font-size-sm">
						<div class="flex-3">Name in your app</div>
						<div class="flex-2">Generic name anyone can understand</div>
					</div>
					<SingleMapping
						v-for="(map, index) in fieldMapping"
						:key="index"
						class="my-1"
						:value="map.originalKey"
						:source="map.originalKey"
						:items="[]"
						:serviceSlug="''"
						disabled
					>
						<div class="input-style">{{ map.displayName }}</div>
					</SingleMapping>
				</div>
			</div>

			<div class="dialog-bottom">
				<SecondaryButton class="display-flex center-margin" x-large @click="close">Got it</SecondaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';

import AppDialog from '../AppDialog/AppDialog';
import DialogHeader from './common/DialogHeader';

import SingleMapping from '@/components/BlockEditorWidget/WidgetFields/DynamicDataMapping/SingleMapping';

const oneMap = () => ({ originalKey: '', displayName: '' });

export default {
	name: 'FinishedCreatingMapperDialog',
	components: {
		AppDialog,
		SingleMapping,
		DialogHeader,
	},
	props: {
		service: { type: Object },
		fieldItem: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	data() {
		return {
			fieldMapping: [oneMap(), oneMap(), oneMap()],
		};
	},
};
</script>

<style lang="scss" scoped>
.finished-creating-mapper-dialog {
	.dummy-mapping {
		padding: 8px;
		border: var(--primary-border);
		border-radius: 8px;
	}
	::v-deep(.app-select) {
		background-color: var(--light-bg-color);
	}
	::v-deep(.v-input) {
		display: none;
	}
}
::v-deep(.app-dialog) {
	min-width: 800px;
}
</style>
